import { EmployeeDto } from '@zorro/clients';
import { parseDateISO } from '@zorro/shared/formatters';

import { buildTitleWithFittedName } from './titleWithFittedName';

export const buildIchraLetterTitle = (
  employee: Pick<EmployeeDto, 'firstName' | 'lastName'>,
  effectiveFrom: string
): string => {
  const suffix = `ICHRA letter ${parseDateISO(effectiveFrom).year()}`;

  return buildTitleWithFittedName(employee, suffix);
};

/**
 * The one name the ICHRA letter downloads under, wherever it is offered. The
 * year comes from the enrollment's effective date, never from the clock: a
 * 2027 enrollment downloaded in December 2026 is still the 2027 letter.
 * Spaced rather than underscored: nothing downstream needs it URL-safe, since
 * the letter is generated per click and never keyed by this name.
 */
export const buildIchraLetterFileName = (
  employee: Pick<EmployeeDto, 'firstName' | 'lastName'>,
  effectiveFrom: string
): string => {
  return `${buildIchraLetterTitle(employee, effectiveFrom)}.pdf`;
};
